
import { Request } from "./data-service";

export class Api {
	/** Component methods **/
	constructor(){
		//this.domain = "http://localhost:8081"; // local 1
		//this.domain = "http://localhost:6100"; // local 2
		this.domain	= "" // production
	}

	/** Public methods **/
	get(request){
		return new Promise(resolve => {
			fetch(this.domain + request.url, request).then(response => {
				return response.json();
			})
			.then(response => {
				resolve(response);
			})

		});
	}

	post(request){
		return new Promise(resolve => {
			fetch(this.domain + request.url, request).then(response => {
				return response.json();
			})
			.then(response => {
				resolve(response);
			})
			.catch( (err) => { console.log("err: ", err);})
			
		})
		.catch( (err) => { console.log("err: ", err);})
				
	}


	put(request){
		return new Promise(resolve => {
			fetch(this.domain + request.url, request).then(response => {
				return response.json();
			})
			.then(response => {
				resolve(response);
			})
			.catch( (err) => { console.log("err: ", err);})
			
		})
		.catch( (err) => { console.log("err: ", err);})
				
	}

}
